<template>
  <v-select
    item-text="text"
    item-value="value"
    :items="items"
    :label="$t('common.fields.status')"
    :value="Number(value)"
    clearable
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    items() {
      return [
        { text: this.$t('common.active'), value: 1 },
        { text: this.$t('common.notActive'), value: 2 },
      ];
    },
  },
};
</script>

<style></style>
